import { styled } from '../../../theme/stitches.config';
import type * as Stitches from '@stitches/react';

const livescoreEntityLogo = {
  width: '$5_5',
  height: '$5_5',
};

const tournamentLogo = {
  width: '32px',
  height: '32px',
};

const mobileTeamIcon = {
  width: '24px',
  height: '24px',
};

export const SMPImage = styled('img', {
  // Reset
  verticalAlign: 'middle',
  maxWidth: '100%',
  boxSizing: 'border-box',
  variants: {
    size: {
      small: {
        size: '$2',
      },
      medium: {
        size: '$4',
      },
      large: {
        size: '$6',
      },
      extraLarge: {
        size: '$8',
      },
    },
    variant: {
      oddProviderLogo: {
        height: '26px',
        '@bp0': {
          maxWidth: '80px',
        },
        '@bp1': {
          maxWidth: '100px',
        },
      },
      sportEntityLogo: {
        size: '$6',
      },
      livescoreEntityLogo,
      tournamentLogo,
      mobileTeamIcon,
      mediumLivescoreEntityLogo: {
        width: '$5',
        height: '$5',
      },
      largeLivescoreEntityLogo: {
        width: '32px',
        height: '32px',
      },
      borderedLivescoreEntityLogo: {
        ...livescoreEntityLogo,
        border: '1px solid $borderColor',
      },
      tennisParticipantLogo: {
        ...livescoreEntityLogo,
        filter: '$invertColor-filter',
      },
      tennisParticipantPlayoffLogo: {
        width: '$5',
        height: '$5',
        filter: '$invertColor-filter',
      },
      tennisParticipantServer: {
        ...livescoreEntityLogo,
        size: '$10',
        mr: '$1',
        backgroundColor: '$participantServerImageColor',
        ml: 'auto',
        br: '$round',
      },
      stakesTeamLogo: {
        size: '$6_5',
      },
    },
  },
});

export type StyledSMPImageVariants = Stitches.VariantProps<typeof SMPImage>;
